module.exports = __webpack_public_path__ + "static/media/placeholder-filled-point.e880dbcc.png";